module.exports = global["_"] = require("-!./underscore-amd-1.4.4.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?_!./public/javascripts/underscore-amd-1.4.4.js-exposed
// module id = 34
// module chunks = 0